module.exports = __webpack_public_path__ + "static/media/hands_15.a939392e.svg";